import api from '@/shared/api';
import { handleApiError } from '@/shared/lib';

import type {
  ProtheusClient,
  ProtheusClientApiResponse,
  ProtheusSupplier,
  ProtheusSupplierApiResponse,
} from '../model/types';

class ProtheusApi {
  async getClients(): Promise<ProtheusClient[]> {
    try {
      const response = await api.get<ProtheusClientApiResponse>('/protheus/clients');
      return response.data.data;
    } catch (error: unknown) {
      throw handleApiError(error, 'Erro ao buscar clientes');
    }
  }

  async getSuppliers(): Promise<ProtheusSupplier[]> {
    try {
      const response = await api.get<ProtheusSupplierApiResponse>('/protheus/suppliers');
      return response.data.data;
    } catch (error: unknown) {
      throw handleApiError(error, 'Erro ao buscar fornecedores');
    }
  }
}

export const protheusApi = new ProtheusApi();
